/* Two equal-length paths: top center -> rounded sides -> bottom center.
   Geometry changes only on resize; CSS handles hover, timing and reduced motion. */
(() => {
  if (!window.customElements || !window.ResizeObserver || customElements.get('irriga-product-outline')) return;

  class IrrigaProductOutline extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      this.observer = new ResizeObserver(([entry]) => {
        if (!entry || !this.isConnected) return;
        const { width: w, height: h } = entry.contentRect;
        const left = this.querySelector('[data-outline-left]');
        const right = this.querySelector('[data-outline-right]');
        if (w <= 0 || h <= 0 || !left || !right) return;

        const radius = Number(this.dataset.radius);
        const r = Math.min(w / 2, h / 2, Math.max(0, Number.isFinite(radius) ? radius : 14));
        const mid = w / 2;
        left.setAttribute('d', `M ${mid} 0 H ${r} A ${r} ${r} 0 0 0 0 ${r} V ${h - r} A ${r} ${r} 0 0 0 ${r} ${h} H ${mid}`);
        right.setAttribute('d', `M ${mid} 0 H ${w - r} A ${r} ${r} 0 0 1 ${w} ${r} V ${h - r} A ${r} ${r} 0 0 1 ${w - r} ${h} H ${mid}`);
        this.setAttribute('data-ready', '');
      });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
    }
  }

  customElements.define('irriga-product-outline', IrrigaProductOutline);
})();
